<template>
  <div
    class="flex flex-wrap items-center justify-between gap-3 bg-white border border-untitled-gray-200 rounded-lg p-3"
  >
    <p class="text-sm text-untitled-gray-500">
      <span class="font-semibold text-untitled-gray-800">{{ totalRecords }}</span>
      {{ totalRecords === 1 ? "video" : "videos" }} uploaded
    </p>
    <div class="sm:max-w-96 min-w-56 w-full sm:w-auto">
      <GroupSelectInput
        v-model="sortSelection"
        :options="sorts"
        label="name"
        value="value"
        :show-icon="true"
        :is-icon="true"
        :icon="AdjustmentsIcon"
        placeholder="Sort By"
      />
    </div>
  </div>
</template>

<script setup>
import { AdjustmentsIcon } from "@heroicons/vue/solid";
import GroupSelectInput from "@/components/layout/inputs/GroupSelectInput.vue";
import { useMyVideosStore } from "@/stores/my-videos/my-videos.store";
import { storeToRefs } from "pinia";
import { computed, defineOptions } from "vue";

defineOptions({
  inheritAttrs: false,
});

const myVideosStore = useMyVideosStore();
const { sortSelection, totalRecords } = storeToRefs(myVideosStore);

const sorts = computed(() => myVideosStore.sorts);
</script>

<style lang="scss" scoped></style>
